import { Component } from '@angular/core';

type OmanTab = 'fixer' | 'filming' | 'about';

@Component({
  selector: 'app-oman',
  templateUrl: './oman.component.html',
  styleUrls: ['./oman.component.scss']
})
export class OmanComponent {
  activeTab: OmanTab = 'fixer';
  openedTabs: Record<OmanTab, boolean> = {
    fixer: true,
    filming: false,
    about: false
  };

  selectTab(tab: OmanTab): void {
    this.activeTab = tab;
    // Keep previously visited tab content mounted, without loading every
    // WordPress section on the initial visit.
    this.openedTabs[tab] = true;
  }

  onTabKeydown(event: KeyboardEvent): void {
    const tabs: OmanTab[] = ['fixer', 'filming', 'about'];
    const currentIndex = tabs.indexOf(this.activeTab);
    let nextIndex: number;

    switch (event.key) {
      case 'ArrowRight':
        nextIndex = (currentIndex + 1) % tabs.length;
        break;
      case 'ArrowLeft':
        nextIndex = (currentIndex + tabs.length - 1) % tabs.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    const nextTab = tabs[nextIndex];
    this.selectTab(nextTab);
    document.getElementById('oman-tab-' + nextTab)?.focus();
  }
}
